import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierLegacioController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierLegacioController.php
* @route '/api/partners/fetch-legacio/{dossier}'
*/
const FetchDossierLegacioController22bded99c8df9ab5b8cc2595d5749ca8 = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchDossierLegacioController22bded99c8df9ab5b8cc2595d5749ca8.url(args, options),
    method: 'post',
})

FetchDossierLegacioController22bded99c8df9ab5b8cc2595d5749ca8.definition = {
    methods: ["post"],
    url: '/api/partners/fetch-legacio/{dossier}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierLegacioController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierLegacioController.php
* @route '/api/partners/fetch-legacio/{dossier}'
*/
FetchDossierLegacioController22bded99c8df9ab5b8cc2595d5749ca8.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return FetchDossierLegacioController22bded99c8df9ab5b8cc2595d5749ca8.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierLegacioController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierLegacioController.php
* @route '/api/partners/fetch-legacio/{dossier}'
*/
FetchDossierLegacioController22bded99c8df9ab5b8cc2595d5749ca8.post = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchDossierLegacioController22bded99c8df9ab5b8cc2595d5749ca8.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierLegacioController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierLegacioController.php
* @route '/api/dossier/{dossier}/legacio'
*/
const FetchDossierLegacioController3c678ca2ca088c586caf807bca0dec89 = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDossierLegacioController3c678ca2ca088c586caf807bca0dec89.url(args, options),
    method: 'get',
})

FetchDossierLegacioController3c678ca2ca088c586caf807bca0dec89.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/legacio',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierLegacioController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierLegacioController.php
* @route '/api/dossier/{dossier}/legacio'
*/
FetchDossierLegacioController3c678ca2ca088c586caf807bca0dec89.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return FetchDossierLegacioController3c678ca2ca088c586caf807bca0dec89.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierLegacioController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierLegacioController.php
* @route '/api/dossier/{dossier}/legacio'
*/
FetchDossierLegacioController3c678ca2ca088c586caf807bca0dec89.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDossierLegacioController3c678ca2ca088c586caf807bca0dec89.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierLegacioController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierLegacioController.php
* @route '/api/dossier/{dossier}/legacio'
*/
FetchDossierLegacioController3c678ca2ca088c586caf807bca0dec89.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchDossierLegacioController3c678ca2ca088c586caf807bca0dec89.url(args, options),
    method: 'head',
})

/**
* Multiple routes resolve to \App\Http\Controllers\Dossier\Partners\FetchDossierLegacioController::FetchDossierLegacioController, so this export is a
* dictionary keyed by URI rather than a callable, with the verbs prefixed where two routes share a URI.
* Call a specific route with `FetchDossierLegacioController['<key>'](...)`, or import the route by name from your
* generated `routes/` directory.
*/
const FetchDossierLegacioController = {
    '/api/partners/fetch-legacio/{dossier}': FetchDossierLegacioController22bded99c8df9ab5b8cc2595d5749ca8,
    '/api/dossier/{dossier}/legacio': FetchDossierLegacioController3c678ca2ca088c586caf807bca0dec89,
}

export default FetchDossierLegacioController